<template>
  <section>
    <h1>取消的报名列表</h1>
<!--    <el-button @click="addFormVisible=true">新增比赛</el-button>-->


    <el-table :data="orderList" highlight-current-row v-loading="false"style="width: 100%;">
<!--      <el-table-column prop="id" label="id" sortable>-->
<!--      </el-table-column>-->
      <el-table-column prop="username" label="手机号">
      </el-table-column>
      <el-table-column prop="name" label="名字" >
      </el-table-column>
      <el-table-column prop="idNumber" label="身份证号" >
      </el-table-column>
      <el-table-column prop="conname" label="分组" >
      </el-table-column>
      <el-table-column align="center" label="原报名时间" >
        <template scope="scope">
          {{ dateFormat( "yyyy-MM-dd hh:mm:ss", new Date(scope.row.origin_at))}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="取消时间" >
        <template scope="scope">
          {{ dateFormat( "yyyy-MM-dd hh:mm:ss", new Date(scope.row.create_at))}}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="取消备注" >
      </el-table-column>
      <el-table-column align="center" label="证件照片" >
        <template scope="scope">
          <a target="_blank" :href="baseUrl+scope.row.photo"> 点击查看 </a>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>

<script>

import {baseUrl} from '../../config.js'
export default {
  name: 'calcelorder2',
  data() {
    return {
      addFormVisible:false,
      orderList:[],
      addForm:{},
      baseUrl,
    }
  },
  methods:{
    dateFormat (format,date) {
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    getData(){
      this.$http.getData('calcelorder2',(data)=>{
        this.orderList=data.result;
      },(data)=>{
        this.$message.error(data.message);
      })
    },
  },
  mounted(){
    this.getData()
  },
}
</script>

<style scoped>
</style>
